import React from 'react'
import Histogram from './histogram'
import axios from 'axios'
import { useEffect, useState } from 'react'

const RiskCalculator = () => {
     // Datos de ejemplo
     const [data, setData] = useState([]);
     const[show, setShow] = useState(false)
     const getRiskValue = async () => {
        await axios.get('http://localhost:8000/risk_value')
            .then(response => {
                console.log("eeee")
                setData(response.data.values); // Asumiendo que la respuesta es un array de valores numéricos
                console.log(response.data)
                setShow(true)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
     }
     useEffect(() => {
        // Hacer la solicitud GET al endpoint
        getRiskValue();
    }, []);
  return (
    <div className='h-1/2 w-1/2'>
        {/* {data.values[0]} */}
        {show && <Histogram data={data}/>}
      
    </div>
  )
}

export default RiskCalculator
